import { render, staticRenderFns } from "./ConfigGeneral.vue?vue&type=template&id=00fed482"
import script from "./ConfigGeneral.vue?vue&type=script&lang=js"
export * from "./ConfigGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports